"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const detail_1 = require("../detail");
exports.emailTemplateBlocksAre = (blocks, ...args) => {
    return !!(blocks || []).find(b => {
        return !!detail_1.emailTemplateBlockIs(b, ...args);
    });
    // switch (type) {
    //   case 'higlighted':
    //     return !!(blocks || []).find(b => {
    //       return !!emailTemplateBlockIs(b, 'higlighted', recurse);
    //     });
    //   case 'clearable':
    //     return !!(blocks || []).find(b => {
    //       return !!emailTemplateBlockIs(b, 'clearable', recurse);
    //     });
    //   case 'userContent':
    //     return !!(blocks || []).find(b => {
    //       return !!emailTemplateBlockIs(b, 'userContent', recurse);
    //     });
    //   case 'anyContent':
    //     return !!(blocks || []).find(b => {
    //       return !!emailTemplateBlockIs(b, 'anyContent', recurse);
    //     });
    //   default:
    //     throw new Error(`emailTemplateBlocksAre has invalid type: ${type}`);
    // }
};
//# sourceMappingURL=emailTemplateBlocksAre.js.map